import React from "react";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { useState, useEffect } from "react";
import { useFormik } from "formik";
import { userService } from "../../../services/extensions"

const PmActionPopup = ({ assignProjectManager, onClose }) => {
  const [managers, setManagers] = useState([]);
  var errormessage = "Please select manager name";

  const formik = useFormik({
    initialValues: {
      manager: null,
    },
    validate: (data) => {
      let errors = {};
      if (!data.manager) {
        errors.manager = <h3>{errormessage}</h3>;
      }
      return errors;
    },
    onSubmit: (data) => {
      assignProjectManager(data);
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  useEffect(() => {
    getManagers();
  }, []);

  const onCloseMethod = () => {
    onClose();
  };

  const getManagers = (param = {}) => {
    userService.getManagers().then((resp) => {
      try {
        resp.data.data.map(
          (user, index) =>
          (managers[index] = {
            id: user.id,
            name:
              user.firstName.charAt(0).toUpperCase() +
              user.firstName.slice(1) +
              " " +
              user.lastName.charAt(0).toUpperCase() +
              user.lastName.slice(1),
          })
        );
      } catch (error) {
        // Error handle
      }
    });
  };

  const changeEvent = (e) => {
    formik.handleChange(e);
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="fields">
        {/* <label><p><hr />PROJECT MANAGERS<hr /></p></label> */}
        <span>
          <Dropdown
            filter
            id="manager"
            name="manager"
            value={formik.values.manager}
            options={managers}
            placeholder="Select project manager"
            optionLabel="name"
            onChange={(e) => {
              changeEvent(e);
            }}
            rows={4}
            cols={20}
            autoResize
            style={{ marginTop: "-20px", width: "330px" }}
          />
          {getFormErrorMessage("manager")}
        </span>

        <div>
          <Button
            type="submit"
            label="Submit"
            onSubmit={formik.handleChange}
            className="p-button-sm p-button-secondary mt-2 ml-2"
            style={{ float: "right" }}
          />
          <Button
            type="button"
            label="Cancel"
            className="p-button-sm p-button-secondary mt-2 ml-2"
            style={{ float: "right" }}
            onClick={(e) => onCloseMethod(e)}
          />
        </div>
      </div>
    </form>
  );
};

export default PmActionPopup;